<p-dialog transitionOptions="0ms" [baseZIndex]="1000" id='updateIntendedUsagePopupId' (onHide)="resetPageMode()" [(visible)]="viewIntUsagepopup" [resizable]="false" class="{{errorDialog?'terminal-ui-popups error-dialog':'terminal-ui-popups plantotrain'}}" [draggable]="false" header="{{popupErrorMessage}}"
    (onShow)='setPageMode({mode: "Dialog", id: "updateIntendedUsagePopupId"});' modal="true" closeOnEscape="true">
    <div class="plan-to">
        <div class="plan-to-dropdown">
            <label><strong> Plan to Train </strong></label>
            <input class="disabled-input" *ngIf="intendedLoco && intendedLoco.plannedAssignment" type="text" contenteditable="false" disabled value="{{intendedLoco?.plannedAssignment}}" style="text-transform: uppercase;">
            <input class="disabled-input" *ngIf="intendedLoco && !intendedLoco.plannedAssignment" type="text" contenteditable="false" disabled value="{{intendedLoco?.plannedOrCurrentAssign}}" style="text-transform: uppercase;">
        </div>
        <div class="clear"></div>
    </div>
    <div class="items-to-plan">

        <div class="plan-loco-table">
            <div class="table">
                <div class="table-header">
                    <div class="columns-loco">Locomotive</div>
                    <div class="columns-iu">Intended Usage </div>
                    <div class="columns-reason">Reason </div>
                    <div class="columns-notes"> </div>
                </div>
                <div class="table-body">
                    <div class="table-row">
                        <lms-intended-usage [indexPosition]='0' [isUpdateIntenedUsage]='true' [tabLevel]='tabLevel' *ngIf="intendedLoco" [locoData]='intendedLoco'></lms-intended-usage>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <div class="dialog-buttons">
        <span class="pull-left">
				<button class="p-button-secondary" tabindex="{{tabLevel+10}}" (click)="hideDialog()">Cancel</button>
			</span>
        <span class="pull-right">
			<button class="p-button-primary" tabindex="{{tabLevel+11}}" id="intUsagePopup" (click)="save()">Submit</button>
			</span>
    </div>
</p-dialog>